import store from '../store/index'
import { axios } from '@/common/api.service.js'

//-----------------------------
// edit static Item (artefact)
//-----------------------------
export default async function useEditStaticItem({ id, payload }, { preview = false } = {}) {
  console.log('-------------------------------------')
  console.log('IN useEditStaticItem....')
  console.log('id:', id, 'payload:', payload)

  if (!id) {
    throw new Error('useEditStaticItem requires a valid item id')
  }

  const baseEndpoint = 'api/v1/items/'
  const endpoint = preview ? `${baseEndpoint}${id}/?preview=true` : `${baseEndpoint}${id}/`

  const isFormData = payload instanceof FormData

  return axios({
    method: 'patch',
    url: endpoint,
    data: payload, // ⭐ DO NOT WRAP OR DEFAULT
    headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {},
    transformRequest: isFormData
      ? [(data) => data] // ⭐ Prevent Axios from serializing FormData
      : axios.defaults.transformRequest,
    mode: 'same-origin',
  })
    .then((response) => {
      console.log('BACK FROM useEditStaticItem:', response)
      if (response?.data) {
        store.commit('characters/setStaticItem', response.data)
      }
      return response
    })
    .catch((error) => {
      console.error('useEditStaticItem error:', error)
      throw error
    })
}

// export default async function useEditStaticItem({ id, payload }, { preview = false } = {}) {
//   console.log('-------------------------------------')
//   console.log('IN useEditStaticItem....')
//   console.log('id:', id, 'payload:', payload)

//   if (!id) {
//     throw new Error('useEditStaticItem requires a valid item id')
//   }

//   const baseEndpoint = 'api/v1/items/'
//   const endpoint = preview ? `${baseEndpoint}${id}/?preview=true` : `${baseEndpoint}${id}/`

//   return axios({
//     method: 'patch',
//     url: endpoint,
//     data: payload || {},
//     mode: 'same-origin',
//   })
//     .then((response) => {
//       console.log('BACK FROM useEditStaticItem:', response)
//       if (response?.data) {
//         store.commit('characters/setStaticItem', response.data)
//       }
//       return response
//     })
//     .catch((error) => {
//       console.error('useEditStaticItem error:', error)
//       throw error
//     })
// }
